import * as React from 'react';

export interface IModalSizes {
	size: 'extraSmall' | 'small' | 'medium' | 'normal' | 'large' | 'fullWidth';
}

interface IProps {
	closeModal?: () => void;
	showHeaderCloseButton?: boolean;
	title?: any;
	subtitle?: JSX.Element | string;
	footer?: any;
	footerPaddingMatchBody?: boolean;
	children?: any;
	modalClass?: any;
	hasThemes?: boolean;
	size?: IModalSizes['size'];
	position?: 'bottom';
	scrollModalToTopOnOpen?: boolean;
	stickyHeader?: boolean;
}

class Modal extends React.Component<IProps, {}> {
	modalRef = React.createRef<HTMLDivElement>();

	componentDidMount() {
		if (this.modalRef.current && this.props.scrollModalToTopOnOpen) {
			this.modalRef.current.scrollTo({ top: 0, behavior: 'auto' });
		}
	}

	public render() {
		const {
			children,
			closeModal,
			title,
			subtitle,
			footer,
			footerPaddingMatchBody,
			showHeaderCloseButton,
			modalClass,
			hasThemes,
			position,
			size,
			stickyHeader,
		} = this.props;

		let closeIconContainer = null;
		if (showHeaderCloseButton) {
			closeIconContainer = (
				<div>
					{hasThemes ? (
						<span className="close" onClick={closeModal} style={{ display: showHeaderCloseButton ? 'block' : 'none' }}>
							<img src={require('containers/Html/icons/close_icon.svg')} className="icon lightIcon" />
							<img src={require('containers/Html/icons/close_black.svg')} className="icon darkIcon" />
						</span>
					) : (
						<span className="close" onClick={closeModal} style={{ display: showHeaderCloseButton ? 'block' : 'none' }}>
							<img src={require('containers/Html/icons/close_icon.svg')} className="icon lightIcon" />
						</span>
					)}
				</div>
			);
		}

		const modalSizes = {
			extraSmall: 'modalExtraSmall',
			small: 'modalSmall',
			medium: 'modalMedium',
			normal: 'modalNormal',
			large: 'modalLarge',
			fullWidth: 'modalFullWidth',
		};

		const modalSize = size ? modalSizes[size] : '';

		let classes = 'modalContainer';
		if (modalClass || modalSize || position) {
			classes = `modalContainer ${modalClass ? modalClass : ''} ${modalSize ? modalSize : ''} ${
				position ? position : ''
			}`;
		}
		let footerContent = null;
		if (footer) {
			footerContent = (
				<div className={`modalFooter ${footerPaddingMatchBody ? 'modalFooterBodyPadding' : ''}`}>{footer}</div>
			);
		}
		let titleContent = null;
		let subtitleContent = null;
		if (title) {
			titleContent = <h1>{title}</h1>;
		}
		if (subtitle) {
			subtitleContent = <h4>{subtitle}</h4>;
		}

		return (
			<div className={classes}>
				<div className="modal" ref={this.modalRef}>
					<div className="modalContent">
						{closeIconContainer || titleContent || subtitleContent ? (
							<div
								className="modalHeader"
								style={
									stickyHeader
										? {
												position: 'sticky',
												top: 0,
												zIndex: 100,
												backgroundColor: 'white',
												borderRadius: '4px 4px 0px 0px',
										  }
										: {}
								}
							>
								{closeIconContainer}
								{titleContent}
								{subtitleContent}
							</div>
						) : null}
						<div className="modalBody">{children}</div>
						{footerContent}
					</div>
				</div>
			</div>
		);
	}
}

export { Modal };
